import type { FaireProductEntity } from "../../entity_types/product";

export const p_fa8dstqa2u: FaireProductEntity = {
  token: "p_fa8dstqa2u",
  type: "product",
  name: "Turmeric Ginger Tonic - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/d361c69300899eed4905f9bf79098d7a28e1bca50b5ee78d1378adc42da2e36b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49bc65caa8c14139621ec543c78b79ddf6187ddfc9c0b7382e73821749bf6a77.png"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nI've got 99 problems...but turmeric just solved 86 of them. Sip and bliss out on this fiery concoction of glowing Turmeric Root, zingy Ginger and Tulsi. It’s an invigorating, soul-soothing, warrior in a cup. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener.\n \nWhen to Steep:\n\n * A nourishing all day caffeine-free tea \n * To soothe your stomach between meals\n * To calm your nerves \n * To boost immunity and reduce inflammation with superfoods \n * As a sugar-free treat before bed. \n\nCaffeine-free\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:39.237Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
